import React from 'react';
import { Grid, Card, CardContent, Typography } from '@deere/fuel-react';
import {COMMODITY_CODE, SBM, SRO} from "../shared/Constants";
import {generateDisplayName} from "../shared/utils";

export const SupplierSbmCard = ({supplierData, supplierNum}) => {
    return (
        <Grid item xs={12}>
            <Card>
                <CardContent style={{ minHeight: supplierNum ? '8rem' : '12rem' }}>
                    <Grid container alignItems="flex-start" spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="label">{SBM}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="label">{SRO}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body1" style={{ marginBottom: "1rem" }}>
                                {generateDisplayName(supplierData.sbm.firstName, supplierData.sbm.lastName, supplierData.sbm.userId)}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body1" style={{ marginBottom: "1rem" }}>
                                {generateDisplayName(supplierData.sro.firstName, supplierData.sro.lastName, supplierData.sro.userId)}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="label">{COMMODITY_CODE}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body1" style={{ marginBottom: ".25rem" }}>
                                {supplierData.commodityCode ? `${supplierData.commodityCode} (${supplierData.commodityName})` : '-'}
                            </Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    );
}